import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewRoles = () => { 
    return useQuery({ 
        queryKey: ['viewroles'], 
        queryFn: async () => { 
            const res = await api.get('/roles/show', {
            }); 
            return res.data; 
        }
     });
};  